<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LrVhB1/tc-custom/9780830893294.jpg?1696025897384" alt="This image is the cover for the book Knowing Scripture"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Knowing Scripture
      </h1>
      <p class="bookDescription body article font2">
        <p>The Bible is the written Word of God, and it is treasured by many. But it is also an ancient book about people and cultures very different than us. Thus, while we know we should read it, many of us have a hard time understanding the Bible. In this expanded edition of<em>Knowing Scripture,</em> R. C. Sproul helps us dig out the meaning of Scripture for ourselves. The author says, "The theme of this book is not how to <em>read</em> the Bible but how to <em>study</em> the Bible." He presents in simple, basic terms a commonsense approach to studying Scripture and gives eleven practical guidelines for biblical interpretation and applying what we learn. With a minimum of technical jargon, Sproul tackles some of the knotty questions regarding differences of interpreting the Bible, including</p>  discovering the meanings of biblical words understanding Hebrew poetry, proverbs and parables approaching historical and didactic passages being careful with predictive prophecy discerning how culture conditions the Bible choosing and using Bible translations, commentaries, Bible software and other helps  <p>Now with a new preface, <em>Knowing Scripture</em> is a basic book for both beginning Bible readers and experienced students of Scripture.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R. C. Sproul, J. I. Packer
      </h2>
      
      <p class="authorDescription body article"><p>R.C. Sproul (1939–2017) was founder Ligonier Ministries, an international Christian discipleship organization located near Orlando, Florida. He was also copastor of Saint Andrew's Chapel in Sanford, Florida, first president of Reformation Bible College, and executive editor of <em>Tabletalk</em> magazine. His radio program, <em>Renewing Your Mind,</em> is still broadcast daily on hundreds of radio stations around the world and can also be heard online. Sproul contributed dozens of articles to national evangelical publications, spoke at conferences, churches, and schools around the world, and wrote more than one hundred books, including<em>The Holiness of God, Chosen by God,</em>and <em>Everyone's a Theologian.</em> He also served as general editor of the <em>Reformation Study Bible</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a9da0fc